import React, { useContext, useState } from 'react';

import './login.css';
import Button from '../../components/button/button';
import { Input } from '../../components/input/input';
import { login } from '../../utils/api';
import { saveToken } from '../../utils/token';
import { UserDataContext } from '../../contexts';

function Login() {
  const [name, setName] = useState<string | undefined>();
  const [error, setError] = useState('');
  const {
    refetchStatus,
  } = useContext(UserDataContext);

  const handleSubmit = async (event?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    try {
      const password = `${name}12345`
      const res = await login(name, password);
      saveToken(res.token);
      await refetchStatus();
    } catch {
      setError('Ошибка входа или регистрации');
    }
  };

  return (
    <section className="register-section">
      <div className="register-wrapper">
        <div className="register-illustration">
          <img src="/images/couple-collage.png" alt="Пара" className="couple" />
          <div className="speech speech-left">Поженимся?</div>
          <div className="speech speech-right">Давай)))</div>
        </div>

        <div className="register-form">
          <h2>Добро пожаловать</h2>
          <form onSubmit={ (e) => { e.preventDefault();} }>
            <Input
              label='Напиши кто ты'
              name='login'
              value={name}
              onChange={e => {
                setError('');
                setName(e.target.value.trim().toLowerCase());
              }}
            />
            <div className='wedding-button'>
              <Button text='свадьбовать' onClick={ handleSubmit } />
            </div>
          </form>
          {error && <p className='error-text'>{error}</p>}
        </div>
      </div>
    </section>
  );
}

export default Login;
